import useSWR from "swr";
import useSWRInfinite, { SWRInfiniteKeyLoader } from "swr/infinite";
import {
  AvatarAssetItem,
  AvatarQuotaResponse,
  MysteryModel,
} from "@/interfaces/nftTypes";
import * as http from "@/utils/request";
import { RFResponse } from "@/interfaces/common";
const baseUrl = process.env.NEXT_PUBLIC_BASE_API;

const PAGE_SIZE = 200;
export const useFilterAvatar = ({
  type,
  value,
  pageNumber = 1,
  pageSize = 10,
}: {
  type: string;
  value: string;
  pageNumber?: number;
  pageSize?: number;
}) => {
  const url = `${baseUrl}/profile/api/nft/avatars?${type}=${value}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

  return useSWR<AvatarAssetItem[] | null>(url, async (url: string) => {
    const { code, data } = await http.get<RFResponse<AvatarAssetItem[]>>(url);
    if (code == 200) {
      return data;
    }
    return null;
  });
};
//

export interface AvatarsResponse {
  data: AvatarAssetItem[];
  nextCursor?: string;
}

export const useFilterAvatarInfinite = ({
  type,
  value,
  ownerMode,
  starRanks = [],
}: {
  type: string;
  value: string;
  ownerMode: number;
  starRanks: number[];
}) => {
  const starRanksQuery =
    starRanks.length > 0 ? `&starRanks=${starRanks.join(",")}` : "";

  const getKey: SWRInfiniteKeyLoader = (pageIndex, previousPageData) => {
    // reached the end
    if (previousPageData && !previousPageData.data) return null;

    // first page, we don't have `previousPageData`
    if (pageIndex === 0) {
      return `${baseUrl}/profile/api/nft/avatars?${type}=${value}&limit=${PAGE_SIZE}&ownerMode=${ownerMode}${starRanksQuery}`;
    }

    return `${baseUrl}/profile/api/nft/avatars?${type}=${value}&cursor=${previousPageData.nextCursor}&limit=${PAGE_SIZE}&ownerMode=${ownerMode}${starRanksQuery}`;
  };

  // infinite除了cursor的方式，只能反悔数组，返回值hardcode用数组包装一下
  const { data, setSize, size, mutate, error } =
    useSWRInfinite<AvatarsResponse>(
      getKey,
      async (url) => {
        const { code, data, _meta } = await http.get<
          RFResponse<AvatarAssetItem[]>
        >(url as string);
        return {
          data: data,
          nextCursor: _meta?.next_cursor,
        };
      },
      {
        initialSize: 1,
        revalidateFirstPage: false,
        revalidateAll: true,
        revalidateOnFocus: false,
      }
    );

  let assets: AvatarAssetItem[] | undefined = undefined;
  if (data) {
    assets = data.reduce(
      (previous, current) => previous.concat(...current.data),
      [] as AvatarAssetItem[]
    );
  }
  const hasMore = data && data[data.length - 1].nextCursor;
  const isLoadingInitialData = !data && !error;
  const isLoadingMore =
    isLoadingInitialData ||
    (size > 0 && data && typeof data[size - 1] === "undefined");

  return {
    data,
    assets,
    mutate,
    setSize,
    size,
    hasMore,
    isLoadingMore,
  };
};

/**
 * 是否拥有礼包
 */
export const useMystery = () => {
  const url = `${baseUrl}/profile/api/nft/avatars/qualifications`;
  return useSWR<MysteryModel | null>(url, async (url: string) => {
    const { code, data } = await http.get<RFResponse<MysteryModel>>(url);
    if (code == 200) {
      return data;
    }
    return null;
  });
};

/**
 * 获取用户入金&拥有状态
 */
export const useAvatarQuota = () => {
  const url = `${baseUrl}/profile/api/nft/avatars/quota`;

  return useSWR<AvatarQuotaResponse>(url, async (url: string) => {
    const { data } = await http.get<RFResponse<AvatarQuotaResponse>>(url);
    return data;
  });
};
